import { Component, OnDestroy, OnInit } from '@angular/core'
import { MatDialog } from '@angular/material/dialog'
import { Store } from '@ngrx/store'
import { UserCloseAccountComponent } from '../account/user-profile/user-close-account/user-close-account.component'
import { selectProfileState } from '../account/user-profile/user-profile.state'
import { Observable, of, switchMap } from 'rxjs'
import { environment } from '../../environments/environment'
import { KeycloakService } from 'keycloak-angular'
import { Router } from '@angular/router'
import { PendingState, selectCustomerPendingState } from '../account/account.root.state'
import { ApiService } from '@api/api.service'
import { MatCardModule } from '@angular/material/card'
import { MatIconModule } from '@angular/material/icon'
import { TranslateModule } from '@ngx-translate/core'
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner'
import { CommonModule } from '@angular/common'
import { MatRippleModule } from '@angular/material/core'
import { GroupsActions } from '../groups/store/groups.actions'
import { selectGroupsData } from '../groups/store/groups.state'
import { GroupsService } from '../groups/groups.service'
import { Subscriptions } from '../utils/subscriptions'

@Component({
  selector: 'cover-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
  imports: [CommonModule, MatRippleModule, MatCardModule, MatIconModule, TranslateModule, MatProgressSpinnerModule],
  standalone: true,
})
export class DashboardComponent implements OnDestroy {
  loadingAdmin: boolean = false
  firstName: Observable<string>
  customerPendingState$: Observable<PendingState>
  isAdminOfGroups: boolean = false
  userProfile$ = this.store.select(selectProfileState.profileState)
  readonly showPasswordReset: boolean = !environment.features.complaintInUserAddress
  readonly pendingState = PendingState
  readonly environment = environment
  readonly ciceroCustomerName: string = 'Res Publica'
  private readonly subscriptions: Subscriptions = new Subscriptions(true)

  constructor(
    private readonly dialog: MatDialog,
    private readonly store: Store,
    private readonly keycloak: KeycloakService,
    private readonly router: Router,
    protected readonly api: ApiService,
  ) {
    this.firstName = store.select(selectProfileState.firstNameState)
    this.customerPendingState$ = this.store.select(selectCustomerPendingState)
  }

  isGreaterThanExtraSmall(): boolean {
    return window.innerWidth > 768
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe()
  }

  navigate(route: string): void {
    this.router.navigateByUrl(route)
  }

  onCloseAccount(): void {
    this.dialog.open(UserCloseAccountComponent)
  }

  changePassword(): void {
    this.keycloak.login({
      action: 'UPDATE_PASSWORD',
      redirectUri: window.location.href,
      // prompt: 'none' // todo: check if this helps in users not having to authenticate themselves again after a certain period
    })
  }

  redirectToOnlineSubscriptions(): void {
    this.api.redirectToOnlineSubscriptions()
  }

  redirectToExternalWebReader(): void {
    this.api.redirectToExternalWebReader()
  }
}
